import React from 'react';

import {
  cats,
  KeyboardShortcutsContext,
  KeyboardShortcutsContextType,
  shortcutsToRegister,
  ShortcutToRegisterType,
} from './KeyboardShortcutsProvider';

export interface WithShortcutsProps {
  enableShortcut: KeyboardShortcutsContextType['enableShortcut'];
}

export {cats};

export function withShortcuts<P extends WithShortcutsProps>(
  shortcut: ShortcutToRegisterType | Array<ShortcutToRegisterType>
): (
  WrappedComponent: React.ComponentType<P>
) => React.ComponentType<Omit<P, keyof WithShortcutsProps>> {
  const shortcuts = Array.isArray(shortcut) ? shortcut : [shortcut];
  shortcuts.map((shortcut) => shortcutsToRegister.push(shortcut));
  let disableShortcut: (key: string) => void;

  return function (WrappedComponent: React.ComponentType<P>) {
    return class EnhancedComponent extends React.PureComponent<
      P & WithShortcutsProps
    > {
      componentWillUnmount() {
        shortcuts.map(({key}) => disableShortcut(key));
      }

      registerShortcuts = (context: KeyboardShortcutsContextType) => {
        disableShortcut = context.disableShortcut;
        return context.enableShortcut;
      };

      render() {
        return (
          <KeyboardShortcutsContext.Consumer>
            {(context) => (
              <WrappedComponent
                {...this.props}
                enableShortcut={this.registerShortcuts(context)}
              />
            )}
          </KeyboardShortcutsContext.Consumer>
        );
      }
    };
  };
}
